export default __webpack_public_path__ + "static/media/information.7fcf8a1f.png";